module.exports = __webpack_public_path__ + "img/item_icon3.b75243e7.png";